import PageLayout from "pages/layout/PageLayout"
import ButtonHasIcon from "components/Button/ButtonHasIcon"
import Typography from "components/Typography"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import { ReactComponent as IconWarning } from "assets/images/icons/icon-form-warning.svg"
import NoWorkspaceImage from "assets/images/workspace-empty.png"
import { useAppSelector } from "hooks/useApp"
import { useEffect } from "react"
export const NotWorkspacePage = () => {
  const userInfo = useAppSelector((state) => state.userInfo)
  const isAddedOrganization = userInfo.is_added_organization
  const handleCreateWorkspace = () => {
    pushTo(PATH.organizationAdd)
  }
  useEffect(() => {
    if (userInfo?.id && userInfo.last_organization_id) {
      pushTo(PATH.projects)
    }
  }, [userInfo?.id])

  return (
    <PageLayout>
      <div className="flex flex-col items-center justify-center h-full bg-[#FFFFFF] relative">
        <div className="flex flex-col items-center justify-center relative">
          <img
            src={NoWorkspaceImage}
            alt="No workspace"
            style={{
              width: 400,
            }}
          />
          <div className="text-center max-w-md">
            <div className="flex flex-col absolute bottom-[70px] left-0 right-0">
              <div className="flex items-center justify-center ">
                <IconWarning className="w-[28px] h-[28px] text-[#E87A16] mr-2" />
                <Typography
                  variant="h5"
                  textClass="font-semibold"
                  style={{ color: "#E87A16" }}
                >
                  You're not part of any workspace
                </Typography>
              </div>
              <Typography textClass="text-[14px] leading-[24px] font-normal text-[#111111] mt-[8px]">
                To access all features, please join or create a workspace.
              </Typography>
            </div>
          </div>
          <div className="mt-[24px]">
            {isAddedOrganization ? (
              <ButtonHasIcon
                title="Create workspace"
                onClick={handleCreateWorkspace}
                widthButton={180}
                heightButton={44}
                textSize={14}
                textWeight={500}
              />
            ) : (
              <div className="min-h-[44px]"></div>
            )}
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
